import React, { forwardRef } from "react";

import { ITypographyProps, Typography } from "../Typography";

export interface ICaptionProps {
  /** Font weight. */
  weight?: "regular" | "bold";
}

export const Caption1 = forwardRef<
  HTMLDivElement,
  ICaptionProps & Omit<ITypographyProps, keyof ICaptionProps | "variant">
>(({ weight = "regular", children, ...props }, ref) => {
  return (
    <Typography variant="Caption 1" weight={weight} ref={ref} {...props}>
      {children}
    </Typography>
  );
});

Caption1.displayName = "Caption1";
